import axios from 'axios'
import constants from '@/constants'

// axios.defaults.baseURL = 'http://192.168.10.30/IMS/public/api/'
// axios.defaults.baseURL = 'http://localhost:8000/api/'
// axios.defaults.withCredentials = true
axios.defaults.baseURL = constants.BASE_API
